import { render, staticRenderFns } from "./SubgroupPaperworkSetForm.vue?vue&type=template&id=6a3e8a65&"
import script from "./SubgroupPaperworkSetForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupPaperworkSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports